<template>
    <div>
        <DCard
            class="mt-5"
            :title="__('customers.customers.critical_actions.headline')"
            padding
        >
            <DListGroup flush>
                <DListGroupItem
                    v-if="customer.status === 'active'"
                    class="p-0"
                >
                    <DCardBody>
                        <DCardTitle>
                            <DRow>
                                <DCol sm="8">
                                    {{ __('customers.customers.critical_actions.fake.name') }}
                                </DCol>
                                <DCol
                                    sm="4"
                                    class="text-right"
                                >
                                    <DButton
                                        v-if="userPermissions.includes('customer.edit')"
                                        :label="__('customers.customers.critical_actions.fake.button_name')"
                                        mini
                                        color="danger"
                                        :disabled="isInLoadingState"
                                        @click="markAsFake"
                                    />
                                </DCol>
                            </DRow>
                        </DCardTitle>
                        <DCardText>
                            {{ __('customers.customers.critical_actions.fake.description') }}
                        </DCardText>
                    </DCardBody>
                </DListGroupItem>

                <DListGroupItem
                    v-if="customer.status === 'fake' || customer.status === 'inactive' || customer.status === 'restricted'"
                    class="p-0"
                >
                    <DCardBody>
                        <DCardTitle>
                            <DRow>
                                <DCol sm="8">
                                    {{ __('customers.customers.critical_actions.reactivate.name') }}
                                </DCol>
                                <DCol
                                    sm="4"
                                    class="text-right"
                                >
                                    <DButton
                                        v-if="userPermissions.includes('customer.edit')"
                                        :label="__('customers.customers.critical_actions.reactivate.button_name')"
                                        mini
                                        color="success"
                                        :disabled="isInLoadingState"
                                        @click="reactivate"
                                    />
                                </DCol>
                            </DRow>
                        </DCardTitle>
                        <DCardText>
                            {{ __('customers.customers.critical_actions.reactivate.description') }}
                        </DCardText>
                    </DCardBody>
                </DListGroupItem>

                <DListGroupItem
                    v-if="customer.status === 'active'"
                    class="p-0"
                >
                    <DCardBody>
                        <DCardTitle>
                            <DRow>
                                <DCol sm="8">
                                    {{ __('customers.customers.critical_actions.deactivate.name') }}
                                </DCol>
                                <DCol
                                    sm="4"
                                    class="text-right"
                                >
                                    <DButton
                                        v-if="userPermissions.includes('customer.edit')"
                                        :label="__('customers.customers.critical_actions.deactivate.button_name')"
                                        mini
                                        color="danger"
                                        :disabled="isInLoadingState"
                                        @click="deactivate"
                                    />
                                </DCol>
                            </DRow>
                        </DCardTitle>
                        <DCardText>
                            {{ __('customers.customers.critical_actions.deactivate.description') }}
                        </DCardText>
                    </DCardBody>
                </DListGroupItem>

                <DListGroupItem
                    v-if="userPermissions.includes('customer.gdpr_restrict') && (customer.status === 'fake' || customer.status === 'inactive')"
                    class="p-0"
                >
                    <DCardBody>
                        <DCardTitle>
                            <DRow>
                                <DCol sm="8">
                                    {{ __('customers.customers.critical_actions.restricted.name') }}
                                </DCol>
                                <DCol
                                    sm="4"
                                    class="text-right"
                                >
                                    <DButton
                                        v-if="userPermissions.includes('customer.gdpr_restrict')"
                                        :label="__('customers.customers.critical_actions.restricted.button_name')"
                                        mini
                                        color="danger"
                                        :disabled="isInLoadingState"
                                        @click="restricted"
                                    />
                                </DCol>
                            </DRow>
                        </DCardTitle>
                        <DCardText>
                            {{ __('customers.customers.critical_actions.restricted.description') }}
                        </DCardText>
                    </DCardBody>
                </DListGroupItem>
            </DListGroup>
        </DCard>

        <DModal
            v-model:show="showActiveContractsExistsModal"
            :title="__('customers.customers.critical_actions.deactivate.modal.title')"
            :message="__('customers.customers.critical_actions.deactivate.responses.error_active_contracts')"
            is-error
            @close="showActiveContractsExistsModal = false"
        />
    </div>
</template>

<script>

export default {
    name: 'CriticalActions',
    props: {
        customer: {
            type: Object,
            default () {
                return {}
            }
        },
        hasActiveContracts: {
            type: Boolean,
            default: () => {
                return true
            }
        }
    },
    emits: ['fake-customer', 'reactivate-customer', 'deactivate-customer', 'restricted-customer'],
    data () {
        return {
            showActiveContractsExistsModal: false
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        markAsFake () {
            this.$emit('fake-customer')
        },
        reactivate () {
            this.$emit('reactivate-customer')
        },
        restricted () {
            this.$emit('restricted-customer')
        },
        deactivate () {
            if (this.hasActiveContracts) {
                this.showActiveContractsExistsModal = true

                return
            }

            this.$emit('deactivate-customer')
        }
    }
}
</script>

<style scoped>

</style>
